<template>
    <section class="main">
        <v-page-header :title="$t('mixingplants.title')" />

        <div class="grid-container">
            <div class="grid-x">
                <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                    <v-action-buttons :items="getActionButtons" />

                    <div class="box">
                        <form
                            action
                            method="POST"
                            class="filter filter--search"
                            novalidation
                            @submit.prevent="onFilterMixingplants"
                        >
                            <div class="filter__grid">
                                <div class="filter__grid__item">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control form-control--small form-control--search"
                                            :placeholder="$t('companyname')"
                                            v-model="mixingplantTableFilter.companyname"
                                        />
                                    </div>
                                </div>
                                <div class="filter__grid__item filter__grid__item--normal">
                                    <div class="form-group form-group--row u-no-margin--bottom">
                                        <div class="form-group form-group--search">
                                            <button
                                                role="button"
                                                type="submit"
                                                class="button"
                                                :title="$t('search')"
                                            >
                                                {{ $t("search") }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <p>
                            {{ resultsTableItems.length }} von {{ resultsTableItemsCount }}
                            <span v-if="resultsTableItemsCount === 1">Mischanlage</span>
                            <span v-else>Mischanlagen</span>
                        </p>
                        <v-table
                            :isLoading="resultsTableLoading"
                            :columns="resultsTableColumns"
                            :items="resultsTableItems"
                            :showHeaderRow="true"
                            :showShowAll="true"
                            :showAll="mixingplantTableFilter.show_all"
                            :useDetailRow="false"
                            @onChangeShowAll="onChangeShowAllTableFilter"
                        >
                            <template slot="name" slot-scope="{ row }">
                                <div class="l-ranking-grid">
                                    <div class="l-ranking-grid__cell">
                                       <span :class="'c-ranking c-ranking--' + (row.ranking || 'none') "></span>
                                    </div>
                                     <div class="l-ranking-grid__cell">
                                        <span class="table-description"> {{ row.name }}</span>
                                    </div>
                                </div>
                            </template>

                            <template slot="address" slot-scope="{ row }">
                                <span class="table-description table-description--normal">
                                    {{ row.address.street }} {{ row.address.housenumber }}
                                </span>
                            </template>

                            <template slot="city" slot-scope="{ row }">
                                <span class="table-description table-description--normal">{{ row.address.city }}</span>
                            </template>

                            <template slot="zipcode" slot-scope="{ row }">
                                <span class="table-description table-description--normal">{{ row.address.zipcode }}</span>
                            </template>

                            <template slot="telephone" slot-scope="{ row }">
                                <span class="table-description table-description--normal">
                                    <a :href="`tel:${row.phone}`">{{ row.phone }}</a>
                                </span>
                            </template>

                            <template slot="email" slot-scope="{ row }">
                                <span class="table-description table-description--normal">
                                    <a :href="`mailto:${row.email}`">{{ row.email }}</a>
                                </span>
                            </template>

                            <template slot="link" slot-scope="{ row }">
                                 <router-link
                                    :to="{ name : 'view-mixingplant', params: { mixingplant: row.id } }"
                                    class="button button--action button--action--edit button--small"
                                    :title="$t('update')"
                                    >{{ $t('update') }}</router-link>
                            </template>
                        </v-table>

                        <v-ranking-legend></v-ranking-legend>

                        <v-pagination
                            :currentPage="resultsTableCurrentPage"
                            :itemsPerPage="resultsTableItemsPerPage"
                            :items="resultsTableItemsCount"
                            @pageClicked="onPaginate"
                        />
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>
<script>
import PageHeader from "./../partials/PageHeader.vue";
import ActionButtons from "./../partials/Foundation/ActionButtons.vue";
import Table from "./../partials/Foundation/Table.vue";
import Pagination from "./../partials/Foundation/Pagination.vue";
import RankingLegend from "./../partials/Rankinglegend.vue";
import vBlocks from "../partials/Foundation/Blocks.vue";

export default {
    name: "Mixingplants",
    data() {
      return {
        selectedMixingplant: null,
        resultsTableLoading: true,
        resultsTableCurrentPage: this.$route.query.page || 1,
        resultsTableItemsPerPage: 10,
        resultsTableItems: [],
        resultsTableItemsCount: 0,
        mixingplantTableFilter: {
            companyname: this.$route.query.companyname || '',
            show_all: ~~(this.$route.query.show_all || 0),
        },
      };
    },

    components: {
      vBlocks,
        vPageHeader: PageHeader,
        vActionButtons: ActionButtons,
        vTable: Table,
        vPagination: Pagination,
        vRankingLegend: RankingLegend,
    },

    computed: {
        resultsTableColumns () {
            return [
                { key: "name", label: this.$t('companyname') },
                { key: "address", label: this.$t('form.account.street') },
                { key: "zipcode", label: this.$t('form.zipcode') },
                { key: "city", label: this.$t('form.account.city') },
                { key: "telephone", label: this.$t('phone') },
                { key: "email", label: this.$t('mail') },
                { key: "link", label: "" },
            ];
        },

        getActionButtons () {
            const buttons = [];

            if (this.$store.getters.userHasPermission("mixingplant_create")) {
                buttons.push({
                    action: "create-new",
                    router: { name: "create-mixingplant" },
                });
            }

            if (this.$store.getters.userHasPermission("mixingplant_list")) {
                buttons.push({
                    action: "search",
                    router: { name: "search-mixingplants" },
                });
            }

            return buttons;
        },
    },

    created () {
        this.updateResultsTableItems();
    },

    methods: {
        /**
         * Get our mixing plants
         */
        updateResultsTableItems () {
            this.resultsTableLoading = true;

            this.$api
                .clearParams()
                .addParam('sortby', 'name')
                .addParam('sortdir', 'asc')
                .addParam('companyname', this.mixingplantTableFilter.companyname)
                .addParam('show_all', this.mixingplantTableFilter.show_all)
                .setPageParams(
                    this.resultsTableCurrentPage,
                    this.resultsTableItemsPerPage
                )
                .get('/mixingplants')
                .then(response => {
                    this.resultsTableItems = response.data.data;
                    this.resultsTableItemsCount = response.data.meta?.pagination?.total

                    this.resultsTableLoading = false;
                }).catch(error => {
                    console.error('Failed to fetch mixingplants from API', error)
                    this.resultsTableItems = [];
                    this.resultsTableItemsCount = 0;

                    this.resultsTableLoading = false;
                });
        },

        onPaginate (page) {
            this.resultsTableCurrentPage = page;
            this.updateResultsTableItems();
        },

        onFilterMixingplants () {
            this.resultsTableCurrentPage = 1;
            this.updateResultsTableItems();
        },
        onChangeShowAllTableFilter : function (show) {
          this.mixingplantTableFilter.show_all = show;

          this.updateResultsTableItems();
        },
    }
 }

</script>
